(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9195],{

/***/ 67801:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(21665);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24100:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/defaultpic.119a8e64.webp","height":269,"width":264,"blurDataURL":"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoIAAgAAkA4JaQAA3AA/vgQAAA=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 18095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _blocks_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23786);
/* harmony import */ var _blocks_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_blocks_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var BlockLoader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_blocks_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["block-loader"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_blocks_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["block-loader__spinner"])
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlockLoader);


/***/ }),

/***/ 64465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69587);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _schemaorg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91257);








var PageHeader = function(props) {
    var _breadcrumb = props.breadcrumb, breadcrumb = _breadcrumb === void 0 ? [] : _breadcrumb, dbName = props.dbName;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var schema = (0,_schemaorg__WEBPACK_IMPORTED_MODULE_6__/* .schemaPageHeader */ .ed)(dbName, router.asPath, breadcrumb);
    if (breadcrumb.length > 0) {
        var lastIndex = breadcrumb.length - 1;
        breadcrumb = breadcrumb.map(function(item, index) {
            var link;
            if (lastIndex === index) {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                            id: schema.name,
                            type: "application/ld+json",
                            dangerouslySetInnerHTML: {
                                __html: JSON.stringify(schema)
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item-active"])),
                            "aria-current": "page",
                            children: item.title
                        })
                    ]
                }, index);
            } else {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: item.url,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: item.title
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedRight6x9Svg */ .EO, {
                            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-arrow"])
                        })
                    ]
                }, index);
            }
            return link;
        });
        breadcrumb = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__breadcrumb"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                "aria-label": "breadcrumb",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default().breadcrumb),
                    children: breadcrumb
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__container"]), " container"),
            children: breadcrumb
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 76193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69587);






var Pagination = function(param) {
    var _current = param.current, current = _current === void 0 ? 1 : _current, _siblings = param.siblings, siblings = _siblings === void 0 ? 1 : _siblings, _total = param.total, total = _total === void 0 ? 1 : _total, onPageChange = param.onPageChange;
    var setPage = function(value) {
        if (value < 1 || value > total || value === current) {
            return;
        }
        try {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
        } catch (e) {
            window.scrollTo(0, 0);
        }
        if (onPageChange) {
            onPageChange(value);
        }
    };
    var getPages = function() {
        var pages = [];
        var min = Math.max(1, current - siblings - Math.max(0, siblings - total + current));
        var max = Math.min(total, min + siblings * 2);
        for(var i = min; i <= max; i += 1){
            pages.push(i);
        }
        return pages;
    };
    var firstLinkClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item"]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item-disabled"]), current <= 1));
    var lastLinkClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item"]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item-disabled"]), current >= total));
    var pages = getPages().map(function(page, index) {
        var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item"]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item-active"]), page === current));
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            className: classes,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                type: "button",
                className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link"]),
                onClick: function() {
                    return setPage(page);
                },
                children: [
                    page,
                    page === current && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["sr-only"]),
                        children: current
                    })
                ]
            })
        }, index);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default().pagination),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: firstLinkClasses,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link--with-arrow"])),
                    "aria-label": "Previous",
                    onClick: function() {
                        return setPage(current - 1);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedLeft8x13Svg */ .lb, {
                        className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link__arrow"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link__arrow--left"])),
                        "aria-hidden": "true"
                    })
                })
            }),
            pages,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: lastLinkClasses,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link--with-arrow"])),
                    "aria-label": "Next",
                    onClick: function() {
                        return setPage(current + 1);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedRight8x13Svg */ .pn, {
                        className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link__arrow"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link__arrow--right"])),
                        "aria-hidden": "true"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 21665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ blog; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./components/blog/blog.module.scss
var blog_module = __webpack_require__(12359);
var blog_module_default = /*#__PURE__*/__webpack_require__.n(blog_module);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./components/schemaorg/index.tsx
var schemaorg = __webpack_require__(91257);
// EXTERNAL MODULE: ./components/blocks/BlockLoader.tsx
var BlockLoader = __webpack_require__(18095);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./images/defaultpic.webp
var defaultpic = __webpack_require__(24100);
// EXTERNAL MODULE: ./components/shared/shared.module.scss
var shared_module = __webpack_require__(12820);
var shared_module_default = /*#__PURE__*/__webpack_require__.n(shared_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
// EXTERNAL MODULE: ./services/utils.js
var utils = __webpack_require__(75681);
;// CONCATENATED MODULE: ./components/shared/PostCard.tsx










var PostCard = function(param) {
    var post = param.post, layout = param.layout, domain = param.domain, dbName = param.dbName, forBLogType = param.forBLogType, translationsData = param.translationsData;
    var _obj;
    var cardClasses = classnames_default()((shared_module_default())["post-card"], (_obj = {}, (0,_define_property/* default */.Z)(_obj, (shared_module_default())["post-card--layout--grid"], [
        "grid-nl",
        "grid-lg"
    ].includes(layout.classic)), (0,_define_property/* default */.Z)(_obj, (shared_module_default())["post-card--layout--list"], [
        "list-nl",
        "list-sm"
    ].includes(layout.classic)), (0,_define_property/* default */.Z)(_obj, (shared_module_default())["post-card--size--nl"], [
        "grid-nl",
        "list-nl"
    ].includes(layout.classic)), (0,_define_property/* default */.Z)(_obj, (shared_module_default())["post-card--size--lg"], layout.classic === "grid-lg"), (0,_define_property/* default */.Z)(_obj, (shared_module_default())["post-card--size--sm"], layout.classic === "list-sm"), _obj));
    var trueImageUrl = post.image ? (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(post.image)) : (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(defaultpic/* default.src */.Z.src));
    var rightDay = post.published_at ? (0,utils/* createRightDate */.UE)(post.published_at) : (0,utils/* createRightDate */.UE)(post.created_at);
    var content = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: cardClasses,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shared_module_default())["post-card__image"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: trueImageUrl,
                        alt: post.blog_title,
                        placeholder: "blur",
                        layout: "fill",
                        priority: true,
                        blurDataURL: "/zega/blur1.webp"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shared_module_default())["post-card__info"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (shared_module_default())["post-card__name"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: forBLogType === "blog" ? post.blog_title : post.name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (shared_module_default())["post-card__read-data"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shared_module_default())["post-card__date"],
                                    children: rightDay
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shared_module_default())["post-card__read-more"],
                                    children: translationsData.ReadMore
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
    var exactUrl = forBLogType === "blog" ? "/blog/".concat(post.url_key) : "/post/".concat(post.slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: exactUrl,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            children: content
        })
    });
};
/* harmony default export */ var shared_PostCard = (PostCard);

// EXTERNAL MODULE: ./components/shared/PageHeader.tsx
var PageHeader = __webpack_require__(64465);
// EXTERNAL MODULE: ./components/shared/Pagination.tsx
var Pagination = __webpack_require__(76193);
;// CONCATENATED MODULE: ./components/blog/BlogPageCategory.tsx











var buildQuery = function(options) {
    var params = {
        page: 0
    };
    if (options.page !== 1) {
        params.page = options.page;
    }
    return query_string.stringify(params, {
        encode: false
    });
};
var BlogPageCategory = function(param) {
    var forBlogType = param.forBlogType, breadcrumb = param.breadcrumb, dbName = param.dbName, domain = param.domain, layout = param.layout, propsBlog = param.blog, translationsData = param.translationsData, selectedLocale = param.selectedLocale;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(propsBlog.current_page), page = ref[0], setPage = ref[1];
    // const [blogs, setBlogs] = useState<[]>(props.blog.data);
    var ref1 = (0,react.useState)(propsBlog.total), total = ref1[0], _ = ref1[1];
    var schema = (0,schemaorg/* schemaBlog */.GQ)(domain, dbName, router.asPath, propsBlog.data, "blog");
    var prevLocaleCodeRef = (0,react.useRef)();
    var prevPageRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        prevPageRef.current = page;
        prevLocaleCodeRef.current = selectedLocale;
    }, []);
    (0,react.useEffect)(function() {
        if (page > 1) {
            var query = buildQuery({
                page: page
            });
            var location = "".concat(window.location.pathname).concat(query ? "?" : "").concat(query);
            window.history.replaceState(null, "", location);
        } else {
            var location1 = "".concat(window.location.pathname);
            window.history.replaceState(null, "", location1);
        }
    }, [
        page
    ]);
    var handlePageChange = function(page) {
        setPage(page);
    };
    if (!propsBlog.data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockLoader/* default */.Z, {});
    }
    var postsList = propsBlog.data.map(function(post) {
        var postLayout = {
            classic: "grid-lg",
            grid: "grid-nl",
            list: "list-nl"
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (blog_module_default())["posts-list__item"],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_PostCard, {
                forBLogType: forBlogType,
                post: post,
                dbName: dbName,
                layout: postLayout,
                domain: domain,
                translationsData: translationsData
            })
        }, post.id);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: schema.name,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schema)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                dbName: dbName,
                header: "Latest News",
                breadcrumb: breadcrumb
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: (blog_module_default())["blog-page-title"],
                                children: translationsData.Blog
                            }),
                            postsList.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "block",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (blog_module_default())["posts-list--layout--".concat(layout)],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (blog_module_default())["posts-list__body"],
                                            children: postsList
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (blog_module_default())["posts-view__pagination"],
                                        children: postsList && postsList.length < 20 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                            current: +page,
                                            siblings: 2,
                                            total: total,
                                            onPageChange: handlePageChange
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (blog_module_default())["products-view__empty"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (blog_module_default())["products-view__empty-title"],
                                    children: translationsData.NothingFound
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var blog_BlogPageCategory = (BlogPageCategory);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/ForCWV/Wrappers/MainLayout.tsx + 31 modules
var MainLayout = __webpack_require__(11416);
;// CONCATENATED MODULE: ./pages/blog/index.tsx









var PageBlog = function(pageProps) {
    var dbName = pageProps.dbName, domain = pageProps.domain, selectedLocale = pageProps.selectedLocale, translationsData = pageProps.translationsData, breadcrumb = pageProps.breadcrumb, blog = pageProps.blog, siteName = pageProps.siteName, defaultLangCode = pageProps.defaultLangCode, locales = pageProps.locales;
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var meta_title = translationsData.Blog;
    var meta_description = "Blog page";
    var meta_keywords = "";
    var meta_url = (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.locale !== "catchAll" && router.locale !== defaultLangCode ? "/" + selectedLocale : "").concat(router.asPath));
    (0,react.useEffect)(function() {
        window.history.replaceState(null, "", window.location.pathname);
    }, [
        query.pageSlug,
        selectedLocale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "keywords",
                            content: meta_keywords
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "generator",
                            content: "Zegashop.com"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "robots",
                            content: "index, follow"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:keywords",
                            content: meta_keywords
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:url",
                            content: meta_url
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:locale",
                            content: selectedLocale
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:site_name",
                            content: siteName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "canonical",
                            href: meta_url
                        }),
                        (locales === null || locales === void 0 ? void 0 : locales.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "alternate",
                                    href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                    hrefLang: "x-default"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "alternate",
                                    href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                    hrefLang: defaultLangCode
                                }),
                                locales.map(function(intl) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(intl.code).concat(router.asPath)),
                                        hrefLang: intl.code
                                    });
                                })
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_BlogPageCategory, {
                    pageSlug: query.pageSlug,
                    breadcrumb: breadcrumb,
                    dbName: dbName,
                    domain: domain,
                    blog: blog,
                    translationsData: translationsData,
                    forBlogType: "blog",
                    selectedLocale: selectedLocale
                })
            ]
        })
    }));
};
var __N_SSP = true;
/* harmony default export */ var blog = (PageBlog);


/***/ }),

/***/ 23786:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block-loader":"blocks_block-loader__kxJ59","block-loader__spinner":"blocks_block-loader__spinner__zfmWE","preloader-animation":"blocks_preloader-animation__7qffr","block-products__featured":"blocks_block-products__featured__EGd2M","product-card-parent":"blocks_product-card-parent__9IJfC","block-products__list":"blocks_block-products__list__yXaFe","block-products__body":"blocks_block-products__body__BL7Wg","block-products-carousel__column":"blocks_block-products-carousel__column__fOCMc","block":"blocks_block__o6zIm","block-products-carousel":"blocks_block-products-carousel__kVyQR","slick-track":"blocks_slick-track__GydZI","slick-list":"blocks_slick-list__RDAcl","slick-slide":"blocks_slick-slide__Hr2SD","correct-slick-active":"blocks_correct-slick-active__a2_Zw","block-products-carousel__preloader":"blocks_block-products-carousel__preloader__QkzPY","block-products-carousel--loading":"blocks_block-products-carousel--loading__dAZ1U","block-products-carousel--has-items":"blocks_block-products-carousel--has-items__Sytel","block-products-carousel__slider":"blocks_block-products-carousel__slider__3UJ_7","block-products-carousel__cell":"blocks_block-products-carousel__cell__5qHDN","home-product-container":"blocks_home-product-container__l9O4Y"};

/***/ }),

/***/ 12359:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"posts-list__item":"blog_posts-list__item__4uaQl","posts-list--layout--classic":"blog_posts-list--layout--classic__WWwea","posts-list--layout--list":"blog_posts-list--layout--list__g627c","posts-list__body":"blog_posts-list__body__lxGlV","posts-list--layout--grid":"blog_posts-list--layout--grid__gtNkO","blog-page-title":"blog_blog-page-title__H8_8b","posts-view__pagination":"blog_posts-view__pagination__P_36F","products-view__empty":"blog_products-view__empty__i1ia1","products-view__empty-title":"blog_products-view__empty-title__MyAiZ","blog_container":"blog_blog_container__7F5F0","typography":"blog_typography__s8_hG","typography--expanded":"blog_typography--expanded__t9afl","post--layout--full":"blog_post--layout--full__xReiC","post__featured":"blog_post__featured__5EXDf","post-header--layout--classic":"blog_post-header--layout--classic__FlmrF","post-header__categories":"blog_post-header__categories__8knrc","post-header__title":"blog_post-header__title___ScKl","post-header__meta":"blog_post-header__meta__Z76lA","post-header--layout--full":"blog_post-header--layout--full__VXW_j","post-header__meta-item":"blog_post-header__meta-item__tKFfe"};

/***/ }),

/***/ 12820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"line__active":"shared_line__active___ydao","under_line__active":"shared_under_line__active__TzH_Z","text-success":"shared_text-success__b_GSc","text-danger":"shared_text-danger__uaRO3","product__prices":"shared_product__prices__CVW7b","color-lightgray":"shared_color-lightgray__tr4MM","product-card__new-price":"shared_product-card__new-price__Uh_wK","product-card__new-price_old_value":"shared_product-card__new-price_old_value__lZEg1","product-card__old-price":"shared_product-card__old-price__qVzw5","test":"shared_test__XJFgh","slick-prevent-click":"shared_slick-prevent-click__46Rz_","product-gallery__carousel":"shared_product-gallery__carousel__rweRi","slick-list":"shared_slick-list__Qm8q0","slick-track":"shared_slick-track__e1on5","product__gallery":"shared_product__gallery__2Qcoo","product-gallery__featured":"shared_product-gallery__featured__7qvkg","product-image__body":"shared_product-image__body___pMPQ","product-image":"shared_product-image__RGE_Z","product-gallery__zoom":"shared_product-gallery__zoom__zE4Rt","product-gallery__carousel-item":"shared_product-gallery__carousel-item__YOaGt","product-image--location--gallery":"shared_product-image--location--gallery__mX462","product-image__img":"shared_product-image__img__7FiK4","owl-carousel":"shared_owl-carousel__DZ_qV","owl-item":"shared_owl-item__1Ipyt","product-gallery__carousel-item--active":"shared_product-gallery__carousel-item--active__Y6uRZ","small-img-car_fms":"shared_small-img-car_fms__trqT1","product-small-img":"shared_product-small-img__19vI8","currency_value":"shared_currency_value__5IPjM","block-header":"shared_block-header__Y47R6","block-header__title":"shared_block-header__title__fNPSo","block-header__divider":"shared_block-header__divider__z_Ltc","block-header__groups-list":"shared_block-header__groups-list__Lcx3T","block-header__title__custom":"shared_block-header__title__custom__sD_wp","title-line-fms":"shared_title-line-fms__G_D1_","title-name-fms":"shared_title-name-fms__dTBlZ","block-header__group":"shared_block-header__group__wwwXx","block-header__group--active":"shared_block-header__group--active__Fl3KN","block-header__arrows-list":"shared_block-header__arrows-list__Acux7","block-header__arrow":"shared_block-header__arrow__IeFTb","block-header__arrow--left":"shared_block-header__arrow--left__UKyJW","block-header__arrow--right":"shared_block-header__arrow--right__KMu9G","breadcrumb":"shared_breadcrumb___jX19","minus_hide":"shared_minus_hide__G0BFC","input-number__input":"shared_input-number__input__pZxDP","input-number__sub":"shared_input-number__sub__8I6_b","input-number__add":"shared_input-number__add__0lk8a","form-control-sm":"shared_form-control-sm__fiyvR","product__quantity":"shared_product__quantity__j3dv_","cart-quantity-responsive":"shared_cart-quantity-responsive__5_4kx","page-header":"shared_page-header__36R5E","breadcrumb-item":"shared_breadcrumb-item__0qre7","breadcrumb-item-active":"shared_breadcrumb-item-active__V3KYS","page-header__breadcrumb":"shared_page-header__breadcrumb__i_Z7a","page-header__title":"shared_page-header__title__JaRFr","breadcrumb-arrow":"shared_breadcrumb-arrow__uQK9o","page-header__container":"shared_page-header__container__mEt_Q","pagination":"shared_pagination__bdXo7","sr-only":"shared_sr-only__9FqOD","page-link":"shared_page-link__CMUmq","page-link--with-arrow":"shared_page-link--with-arrow__c1IUc","page-link__arrow":"shared_page-link__arrow__mULrQ","page-link__arrow--left":"shared_page-link__arrow--left___61oN","page-link__arrow--right":"shared_page-link__arrow--right__k9sB2","page-item":"shared_page-item__dpA_F","page-item-disabled":"shared_page-item-disabled__DERIG","page-item-active":"shared_page-item-active__MPK7e","bottomNavigation-wrapper":"shared_bottomNavigation-wrapper__qch5s","indicatpr_area":"shared_indicatpr_area__8uOGn","bottom-nav-item--title":"shared_bottom-nav-item--title__vcuz0","bottom-nav-item--title-active":"shared_bottom-nav-item--title-active__XLHhd","local-item":"shared_local-item__lM6aT","local-item-active":"shared_local-item-active__SLCm2","active":"shared_active__9Ifpg","bottom-nav-item":"shared_bottom-nav-item__O_XHs","bottom-nav":"shared_bottom-nav__H2kJw","indicator__value":"shared_indicator__value__WOLbt","indicator":"shared_indicator__H_FQK","false":"shared_false___CPLZ","indicator__area":"shared_indicator__area__th4gv","mob_area":"shared_mob_area___TbbM","block-posts":"shared_block-posts___KdlJ","slick-slide":"shared_slick-slide__A6TQC","post-card":"shared_post-card__iG54_","block-posts--layout--list-sm":"shared_block-posts--layout--list-sm__U1MbP","post-card__image":"shared_post-card__image__7N_gj","post-card__name":"shared_post-card__name__mtEZ3","post-card__date":"shared_post-card__date__Vl_uC","post-card__category":"shared_post-card__category__tfnxa","post-card__content":"shared_post-card__content__WkHA7","post-card__read-more":"shared_post-card__read-more__8ZXB_","post-card__info":"shared_post-card__info__hGWgj","block-posts--layout--grid-nl":"shared_block-posts--layout--grid-nl__A6c3z","post-card__read-data":"shared_post-card__read-data__D4d0W","post-card--layout--related":"shared_post-card--layout--related__XefJD","post-card--layout--grid":"shared_post-card--layout--grid__e3_ld","post-card--size--lg":"shared_post-card--size--lg__x_1XA","post-card--layout--list":"shared_post-card--layout--list__wvqDN","post-card--size--nl":"shared_post-card--size--nl__AJ2H2","post-card--size--sm":"shared_post-card--size--sm__6Zwvl","social-links__list":"shared_social-links__list__dfW3w","social-links__item":"shared_social-links__item__7uXma","social-links__link":"shared_social-links__link__b_S9g","social-links--shape--circle":"shared_social-links--shape--circle__YFFEi","social-links--shape--rounded":"shared_social-links--shape--rounded__TT0YX","social-links__link--type--facebook":"shared_social-links__link--type--facebook__G719K","social-links__link--type--twitter":"shared_social-links__link--type--twitter__7ulYd","social-links__link--type--youtube":"shared_social-links__link--type--youtube__FWKHG","social-links__link--type--instagram":"shared_social-links__link--type--instagram___32Vy","social-links__link--type--rss":"shared_social-links__link--type--rss___vbZg","wishlist-circle":"shared_wishlist-circle__IHvkp","wishlist-icon-wrapper":"shared_wishlist-icon-wrapper__pW_9v","wishlist-circle-clicked":"shared_wishlist-circle-clicked__ZBHpI","inner-wishlist":"shared_inner-wishlist__S07T4","product-card__prices":"shared_product-card__prices__OXbim","uPsell-title":"shared_uPsell-title__TIb25","upsell_body":"shared_upsell_body__5qzyA","product__content":"shared_product__content__zHVz_","product__info":"shared_product__info__2JUdC","short_description_block":"shared_short_description_block__hIkfU","product-inner-description-title":"shared_product-inner-description-title__h9vAb","product__meta":"shared_product__meta__EwL40","product__sidebar":"shared_product__sidebar__O9bRJ","product__options":"shared_product__options__2X85W","product__actions":"shared_product__actions__dAK_0","no-thanks":"shared_no-thanks__G__wn","btn":"shared_btn__2IzVc","btn-orange":"shared_btn-orange__zc5e3","rounded-pills":"shared_rounded-pills__Z7qlr","product__name":"shared_product__name__QUTXW","ups-product__info":"shared_ups-product__info__W_YrR","item_overlay":"shared_item_overlay__qz1Am","product-card__image":"shared_product-card__image__IroED","cross__prods":"shared_cross__prods__xJAFI","input-number":"shared_input-number__mS_oj","product-image__default-fms":"shared_product-image__default-fms__0xjYL","product__actions-item--addToCart":"shared_product__actions-item--addToCart__dHUJi"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3061,7838,6033,3997,9774,2888,179], function() { return __webpack_exec__(67801); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);